module.exports = __webpack_public_path__ + "components/flag/static/square/gi-3416b8bd02cd4dbe0c5f87e9cb84fda8.svg";